
import path from 'path'
import { defineComponent, PropType, ref, toRefs } from 'vue'
import MenuItemIcon from './menuItemIcon'
import AppLink from './Link.vue'
import { isExternal } from '@/utils/validate'
import { AppRouteRecordRaw } from '@/common/types/appRoute.type'

interface ISidebarItemProps {
  item: AppRouteRecordRaw[] | Record<string, any>
  isNest: boolean
  basePath: string
}

export default defineComponent({
  name: 'SidebarItem',
  components: { MenuItemIcon, AppLink },
  props: {
    item: {
      type: Object as PropType<AppRouteRecordRaw>,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    // const data = reactive({
    //   onlyOneChild: null
    // })
    const { basePath } = toRefs<ISidebarItemProps>(props)
    const onlyOneChild = ref<AppRouteRecordRaw>()
    const hasOneShowingChild = (children: Array<AppRouteRecordRaw> = [], parent: AppRouteRecordRaw): boolean => {
      const showingChildren = children.filter(route => {
        if (route.hidden) return false
        onlyOneChild.value = route
        return true
      })
      if (showingChildren.length === 1) return true
      if (showingChildren.length === 0) {
        onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    }
    const resolvePath = (routePath: string): string => {
      if (isExternal(routePath)) return routePath
      if (isExternal(basePath.value)) return basePath.value
      return path.resolve(basePath.value, routePath)
    }

    return {
      onlyOneChild,
      hasOneShowingChild,
      resolvePath
    }
  }
})
